<div class="modal-content">
  <div class="modal-header">
    <p *ngIf="!employeeAddress" class="modal-title font-16 text-dark">{{ 'employees_addresses.page_title_create' | translate }}</p>
    <p *ngIf="employeeAddress" class="modal-title font-16 text-dark">{{ 'employees_addresses.page_title_edit' | translate }}</p>
    <button (click)="activeModal.dismiss()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="font-24 text-muted"><i class="mdi mdi-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <app-address-form #childRef
                              [employeeAddress]="employeeAddress"
                              [presetPrimaryAddress]="presetPrimaryAddress"
                              [submitted]="submitted">
            </app-address-form>
            <div *ngIf="(!employeeAddress && employee?.permissions?.createAddressWithApproval) || (employeeAddress && (employee?.permissions?.editAddressWithApproval || employee?.permissions?.deleteAddressWithApproval))"
                 class="row">
              <div class="col-12 text-right">
                <p class="text-muted mb-1"><small> {{ 'employees_addresses.request_will_be_sent' | translate }} </small></p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-link text-muted p-0 mr-2">
                  <u (click)="deleteAddress()" *ngIf="employeeAddress && (employee?.permissions?.deleteAddress || employee?.permissions?.deleteAddressWithApproval)"
                     class="text-muted">{{ 'global.action_delete'  | translate }}</u>
                </button>
                <button (click)="onSubmit()" [disabled]="updateRequested" class="btn btn-success" type="submit">{{ 'global.action_save' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
